import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { useAuth } from "../helpers/useAuth";
import { oauthNativeResult } from "../helpers/oauthNativeResult";
import { oauthNativeEngine } from "../helpers/oauthNativeEngine";

export const OAuthDeepLinkHandler = () => {
  const navigate = useNavigate();
  const { onLogin } = useAuth();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    console.log("[oauth-native] handler mounted");
    oauthNativeEngine.ensureAttached();
    oauthNativeEngine.resumePendingAttempt();

    const handleResult = (detail: any) => {
      if (detail.status === "success" && detail.user) {
        onLogin(detail.user);
        const redirectPath = detail.user.role === "tenant" ? "/tenant-portal/dashboard" : "/dashboard";
        setTimeout(() => navigate(redirectPath, { replace: true }), 200);
      }
    };

    const pending = oauthNativeEngine.consumePendingResult();
    if (pending) {
      handleResult(pending);
    }

    const unsubscribe = oauthNativeResult.subscribe(handleResult);
    return () => unsubscribe();
  }, [navigate, onLogin]);

  return null;
};